import { cBigNumber } from "./BigNumber";
import { iBalance, iBalanceResponse, iOption, zeroBN } from "../interfaces/interfaces";
import { store } from "../store/store";
import { cOption } from "./option";


export class cBalance implements iBalance{
	fullBalance: cBigNumber;
	exerciseBalance: cBigNumber;
	lockedBalance: cBigNumber;
	createdBalance: cBigNumber;
	borrowBalance: cBigNumber;

	availableBalance: cBigNumber;
	isShowedYourDesc: boolean;
	isShowedCreatedDesc: boolean;
	fullExButtonShowed = false;      // basic
	cancelExButtonShowed = false;    // basic
	finalizeExButtonShowed = false;
	uncreateButtonShowed = false;
	withdrawButtonShowed = false;
	borrowButtonShowed = false;
	opt: iOption;
	isExpired: boolean;

	optId: string | undefined;     // chromia field
	isShowedChrDesc: boolean;


	constructor (responseBalance: iBalanceResponse){
		this.fullBalance = new cBigNumber(responseBalance.full_balance);
		this.exerciseBalance =  new cBigNumber(responseBalance.exercise_balance);
		this.lockedBalance =  new cBigNumber(responseBalance.locked_balance);
		this.createdBalance =  new cBigNumber(responseBalance.created_balance);
		this.borrowBalance =  new cBigNumber(responseBalance.borrow_balance);

		const { systemTimestamp, config } = store.getState().app;
		if (systemTimestamp === null || !config) throw new Error(
			'Error code: 5_0' +
			(systemTimestamp?'' : '\ntime: -') +
			(config? '' : '\nconfig: -')
		);

		const opt = responseBalance.opt;
		const autoexerciseTime = config.eopt.autoexerciseTime * 60;

		// available_balance
		this.availableBalance = this.fullBalance.sub(this.exerciseBalance).sub(this.lockedBalance);

		// is showed for your_options_table
		const isAutoexercised = +opt.maturity_price > 0
			? opt.call_type
				? +opt.maturity_price > +opt.strike
				: +opt.maturity_price < +opt.strike
			: false
		;
		const hasBalance = opt.maturity_time + autoexerciseTime > systemTimestamp && this.fullBalance.gt(zeroBN);
		const hasExBalance = opt.maturity_time + autoexerciseTime < systemTimestamp && this.exerciseBalance.gt(zeroBN);
		this.isShowedYourDesc = isAutoexercised || hasBalance || hasExBalance;

		// is showed for created_options_table
		this.isShowedCreatedDesc = this.createdBalance.gt(zeroBN);

		this.isExpired = systemTimestamp > opt.maturity_time;

		// buttons
		if (systemTimestamp > opt.maturity_time + autoexerciseTime){  // option has expired and autoexercise time has passed
			if (this.exerciseBalance.gt(zeroBN)){
				this.finalizeExButtonShowed = true;
			}
			if (this.createdBalance.gt(zeroBN)){
				this.withdrawButtonShowed = true;
			}
		}
		if (!this.isExpired) {    // option not expired
			if (this.createdBalance.gt(zeroBN) && this.availableBalance.gt(zeroBN)){
				this.uncreateButtonShowed = true;
			}
			if (this.availableBalance.gt(zeroBN)){
				this.fullExButtonShowed = true;
			}
			if (this.exerciseBalance.gt(zeroBN)){
				this.cancelExButtonShowed = true;
			}
			if ((this.borrowBalance.gt(zeroBN) || this.availableBalance.gt(zeroBN)) && opt.call_type){  // available only for calls
				this.borrowButtonShowed = true;
			}
		}

		// opt
		this.opt = new cOption(responseBalance.opt);

		// chromia
		this.optId = responseBalance.opt_id?.toString('hex');
		this.isShowedChrDesc = systemTimestamp < opt.maturity_time
			? true  // not expired
			: this.availableBalance.gt(zeroBN)
		;
	}
}